import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

import ISODateTime from "components/formatting/ISODateTime";
import ISOPercentage from "components/formatting/ISOPercentage";
import { BillingUsageEmail } from "../types/BillingUsageEmail";

interface BillingUsageEmailListProps {
  emailNotifications: Array<BillingUsageEmail>;
}

export default function BillingUsageEmailList(props: BillingUsageEmailListProps): React.JSX.Element {
  const { i18n } = useTranslation();
  const theme = useTheme();
  return (
    <Box>
      <Typography variant="h4">{i18n.t("billing-usage-email-list.notifications-heading")}</Typography>
      {props.emailNotifications.map((notification) => {
        let color = theme.colors.warning.main;
        if (notification.pct_consumed >= 0.9) {
          color = theme.colors.error.main;
        }
        return (
          <Box key={notification.id}>
            <span>{i18n.t("billing-usage-email-list.sent-on")}</span>
            <ISODateTime isoString={notification.created_at} hideTime={true} />
            <span>{i18n.t("billing-usage-email-list.for")}</span>
            <span style={{color: color}}>
              <ISOPercentage sx={{display: "inline", fontWeight: "bold"}} value={notification.pct_consumed} />
            </span>
            <span>{i18n.t("billing-usage-email-list.usage")}</span>
          </Box>
        )
      })}
    </Box>
  )
}